export default __webpack_public_path__ + "static/media/nav_other.1ed265ab.svg";